/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Define como se manejara los nulls en el orden.
 */
export type SortNullHandling = 'NATIVE' | 'NULLS_FIRST' | 'NULLS_LAST';

export const SortNullHandling = {
    NATIVE: 'NATIVE' as SortNullHandling,
    NULLSFIRST: 'NULLS_FIRST' as SortNullHandling,
    NULLSLAST: 'NULLS_LAST' as SortNullHandling
};

